import { useCreateEntity, useDeleteEntity } from '@abaninja/util-store';

import { addSupportUser, removeSupportUser } from '../support';

export const useSupportUser = () => ({
  ...useCreateEntity(addSupportUser),
  ...useDeleteEntity(removeSupportUser),
});
